<!DOCTYPE html>
<ion-content>
  <div class="main-container">
    <ion-row class="main-header">
      <ion-col class="heading-wrap ion-no-padding" size="11"></ion-col>
      <ion-col class="notification-wrap ion-no-padding" size="1" (click)="goBack()">
        <img class="support-img" src="assets/images/close-circle.png" />
      </ion-col>
    </ion-row>
    <div class="links-card">
      <ion-card no-lines>
        <p><strong>{{ 'help-confirmation.need_help_title' | translate }}</strong>  
          {{ 'help-confirmation.need_help_subtitle' | translate }}</p>
        <div class="btn-wrapper">
          <button type="button" (click)="goToGetHelpPage()">{{ 'help-confirmation.get_help' | translate }}</button>
        </div>
      </ion-card>
      <ion-card no-lines>
        <div [innerHTML]="'request-data.description' | translate | safeHtml"></div>
      </ion-card>
      <div class="footer-text"> 
        <p>{{ 'close-confirmation.footer_text' | translate }} <br/> <a (click)="goToDeleteAccountPage()" class="link">{{ 'LOGINPAGE.Click here' | translate }}</a></p>
        <div class="btn-wrapper">
          <button type="button" (click)="onRequestData()">{{ 'request-data.request_data' | translate }}</button>
        </div>
      </div>
    </div>
  </div> 
</ion-content>
